<template>
  <div>
    <DropDownMenu drop-down-icon="none" class="contact-type-dropdown" :disabled="disabled" @open="setActive">
      <template v-slot:trigger>
        <button class="button" :class="{ 'dropdown-active': active }" :disabled="disabled">
          <div class="selected-type-label">
            <div class="contacts-icon">
              <font-awesome-icon icon="user-friends"></font-awesome-icon>
            </div>

            <div class="selected-type-text">
              {{ getFormattedType(selectedType) }}
            </div>
          </div>
        </button>
      </template>
      <div class="scrollable-item-list">
        <a
          :id="'contact-type-item-' + contactType"
          class="dropdown-item"
          v-for="contactType in getContactTypes()"
          :key="contactType"
          @click="selectType(contactType)"
        >
          {{ getFormattedType(contactType) }}
        </a>
      </div>
    </DropDownMenu>
  </div>
</template>

<script lang="ts" setup>
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import { ContactType } from '@/features/contacts/models/contactType';
import { onMounted, PropType, ref } from 'vue';

const props = defineProps({
  value: {
    type: String as PropType<ContactType>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: 'false',
  },
});

const emit = defineEmits<{
  (e: 'updated-type', type: ContactType): void;
}>();

const selectedType = ref(ContactType.User);
const active = ref(false);

onMounted(() => (selectedType.value = props.value));

function getContactTypes(): ContactType[] {
  return [ContactType.Lead, ContactType.User];
}

function selectType(type: ContactType) {
  if (props.disabled) {
    return;
  }

  if (selectedType.value !== type) {
    emit('updated-type', type);
  }
  selectedType.value = type;
  active.value = false;
}

function getFormattedType(type: ContactType): string {
  return `${type.charAt(0).toUpperCase()}${type.slice(1)}s`;
}

function setActive(isOpen: boolean) {
  if (props.disabled) {
    return;
  }

  active.value = isOpen;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.selected-type-label {
  display: flex;
}

.selected-type-text {
  padding-left: 0.5em;
}

.button {
  border-radius: 4px;
  background-color: #eee;
  border: solid 1px #eee;

  &:hover {
    color: inherit;
    background-color: #ccc;
    border: solid 1px #ccc;
  }

  &:focus {
    color: inherit;
    border-color: #eee;
    outline: none;

    &:hover {
      border-color: #eee;
    }
  }

  &:focus:not(:active) {
    box-shadow: none;
  }

  &.dropdown-active {
    background-color: #ddd;
    border: solid 1px #ddd;
  }

  &.disabled {
    opacity: 0.6;
    cursor: default;
  }
}

:deep(.dropdown-menu) {
  width: 100%;
  min-width: 0;
}

a.dropdown-item {
  padding-right: 0;
}
</style>
